import React from 'react'

interface SummaryProps {
	unit: string
	value: string | number
	title: string
}

const BaseSummary = (props: SummaryProps) => {
	return (
		<div className='container'>
			<span>
				{props.value}
				<span className='unit'> {props.unit}</span>
			</span>
			<span className='title'>{props.title}</span>
		</div>
	)
}

export default BaseSummary
